export type TimePeriod = (typeof TIME_PERIOD)[keyof typeof TIME_PERIOD];
export const TIME_PERIOD = {
	DAY_VIEW: 'day',
	WEEK_VIEW: 'week',
} as const;
